module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Many of the expressions in category (1) and all the expressions in category (2) are not words but phrases; and the anglicization-of phrases is less straightforward than that of single words. A phrase may be anglicized in one or other of two ways: the sounds and stresses may be accommodated to those of English, as in the case of "), _c('a', {
    attrs: {
      "id": "page_23"
    }
  }), _vm._v("single words, or the phrase may be translated into English. The accommodation of sounds and stresses to the English pattern is comparatively rare, for obvious reasons: the result would be a collocation of unfamiliar words, the syntactic relationship between which could only be a matter of conjecture. Accommodation of this kind seems only to happen when all the words of which the phrase is composed already exist in English in an anglicized form. Thus the anglicization of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("court martial")]), _vm._v(" depends on the prior existence of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("court")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("martial")]), _vm._v(" as anglicized words; despite the unEnglish wordorder—noun followed by adjective—the syntactic relationship between the two words is obvious. Yet the unusual word order is so far objectionable that the phrase is now tending to be replaced by a compound noun "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("court-martial,")]), _vm._v(" with plural "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("court-martials")]), _vm._v(" instead of the traditional "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("courts martial.")]), _vm._v(" Another interesting example is the legal phrase "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("malice prepense,")]), _vm._v(" which has the same unEnglish wordorder; here the great rarity of the adjective "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("prepense,")]), _vm._v(" which scarcely occurs outside this phrase, has encouraged the development of the partially translated form "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("malice aforethought,")]), _vm._v(" in which the unEnglish word-order accords ill with the conspicuously Saxon adjective "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("aforethought")]), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Introduction_2#A15",
      "id": "B15"
    }
  }, [_vm._v("1")])]), _vm._v(". The translation of a ‘foreign’ phrase is also comparatively rare. French "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ça va sans dire")]), _vm._v(" has entered English in translation as ‘that goes without saying’, which despite the objections of purists no longer has a ‘foreign’ ring. On the other hand, the translation of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ça saute aux yeux")]), _vm._v(" as ‘it jumps to the eyes’ sounds awkward, and is rarely used. It should be noted that, by the very definition of the category, the translation of phrases in category (2) is out of the question.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The anglicization of a substantial number of words is put out of court by the fact that the normal accommodation of sounds and stress to the English pattern would result in a word identical in form with an existing word of quite different meaning. Thus, the French word "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("emplacement")]), _vm._v(" would, if anglicized, become identical with the English military term ‘emplacement’; French "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("enfilade")]), _vm._v(" with the military term ‘enfilade’; French "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("facile")]), _vm._v(" with English ‘facile’, which has quite a different connotation; French "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("franchise")]), _vm._v(" with English ‘franchise’; and so on. Of course the ‘English’ word with which confusion is "), _c('a', {
    attrs: {
      "id": "page_24"
    }
  }), _vm._v("likely is in every case an anglicization of earlier date; the point is that if a foreign word already anglicized in one sense is adopted again in a slightly different sense it must remain forever ‘foreign’, since otherwise its distinctive meaning would not be discernible. Similarly, if French "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("conservatoire")]), _vm._v(" were to be anglicized it could only become ‘conservatory’; and there already exists in English a word of this form with quite a different meaning—‘a glass-house opening out of a drawing-room’. It is noteworthy that in the United States, where the meaning ‘glass-house’ is not in use, the French word has in fact been anglicized as "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("conservatory.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In a slightly different class are such technical or quasi-technical terms as "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("gravitas")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("scientia,")]), _vm._v(" which could only be anglicized as ‘gravity’ and ‘science’; but each of these two words has undergone a special development of sense in English which is inappropriate to the technical use. Although "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("gravity")]), _vm._v(" still retains the meaning ‘weightiness (of demeanour)’, there is a likelihood of confusion with the scientific sense ‘the force attracting two bodies one to another’; and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("science")]), _vm._v(" now means only ‘the study of natural physical phenomena’, not ‘systematic knowledge (of any subject)’. Still more complicated are the cases in which two or more similar or closely related words have been borrowed from different languages, each with its own special connotation. One example has been given above ("), _c('a', {
    attrs: {
      "href": "#/xhtml/05_Introduction#page_20"
    }
  }, [_vm._v("p. 20")]), _vm._v("): "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("staccato")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("détaché")]), _vm._v(" both mean ‘detached’, but each has a distinct technical connotation lacking from the English word. Similarly "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("maniéré")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("manieroso")]), _vm._v(" both correspond to English ‘mannered’, yet neither means quite the same as the English word. Perhaps the most complicated example of all is provided by the three words "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("nouvelle")]), _vm._v(" (French), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("novella")]), _vm._v(" (Italian), and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Novelle")]), _vm._v(" (German); each of these is a term of literary criticism, and each has a distinct connotation; if any of them were to be anglicized it could only be as ‘novel’, identical in form with an English term of literary criticism which means something quite different again.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But over and above these special considerations there is a general consideration of compelling force. Just as the technical terms in categories (5) and (6) have special connotations in their various languages of origin, so every word in every language has special connotations not all of which will be associated with the equivalent word in some other language. If a word refers to some concrete object or to some commonplace idea it is unlikely that the connotations will be of any great importance, and the anglicization of a foreign word of this type will occasion no noticeable loss. But if a word refers to some vague abstract concept difficult to define, it is likely that the field of connotation (ultimately derived from numerous literary "), _c('a', {
    attrs: {
      "id": "page_25"
    }
  }), _vm._v("and spoken usages more or less familiar to those who use the word) will be of the first importance; and anglicization is likely to destroy this field of connotation. Thus, to take only one instance out of a large number, such a word as "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("frisson")]), _vm._v(" could very easily be anglicized in pronunciation, so that it would rhyme with the English word "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("listen;")]), _vm._v(" but the word so anglicized would fail to call to mind the various occurrences of the word in French literature and in French spoken idiom which are ultimately responsible for the characteristic and practically untranslatable meaning of the word in its French form. Words of this kind are very frequent among the ‘foreign’ expressions used in English, and no duration of time or frequency of usage is likely to result in their anglicization.")]), _vm._v(" "), _c('h4', {
    staticClass: "head2",
    attrs: {
      "id": "id13"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE DATING OF")]), _vm._v(" ‘"), _c('span', {
    staticClass: "small"
  }, [_vm._v("FOREIGN")]), _vm._v("’ "), _c('span', {
    staticClass: "small"
  }, [_vm._v("EXPRESSIONS")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("It is interesting and in some respects enlightening to classify the ‘foreign’ expressions in English according to the language from which they come and the approximate date at which they were introduced into English. Unfortunately the accurate dating of these expressions is somewhat difficult. The only authorities are the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("New English Dictionary")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The Stanford Dictionary of Anglicised Words and Phrases")]), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Introduction_2#A16",
      "id": "B16"
    }
  }, [_vm._v("1")])]), _vm._v(", and neither is wholly satisfactory from this point of view. The earlier volumes of the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("New English Dictionary")]), _vm._v(" are markedly deficient in ‘foreign’ terms, and although many of the deficiencies are supplied in the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Supplement")]), _vm._v(" of 1933, the work as a whole includes only a relatively small number of phrases. "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Stanford")]), _vm._v(" includes a much larger selection of phrases than the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("New English Dictionary,")]), _vm._v(" but its dating is much less trustworthy; if a word or phrase appears in both works the earliest quotation in the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("New English Dictionary")]), _vm._v(" is very often earlier, sometimes much earlier, than the earliest in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Stanford.")]), _vm._v(" For a number of phrases I have been able to supply from my own reading an earlier date than that given in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Stanford;")]), _vm._v(" but much work still remains to be done in hunting out early quotations illustrating the use of ‘foreign’ phrases. However, even allowing for possible error in the dating of the phrases, the study of the dates at which ‘foreign’ expressions were introduced into English reveals many points of interest. Full details are given in the Appendix, pp. 369–89, but the Tables in the following section give the information in summary form.")]), _vm._v(" "), _c('h4', {
    staticClass: "head2",
    attrs: {
      "id": "id14"
    }
  }, [_vm._v("S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OME TABLES OF STATISTICS")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/06_Introduction_1#tab_I"
    }
  }, [_vm._v("Table I")]), _vm._v(" shows the actual number of words and phrases adopted from each language or group of languages, subdivided according to the "), _c('a', {
    attrs: {
      "id": "page_26"
    }
  }), _vm._v("century in which they were introduced. Words and phrases are listed under the language from which they were actually adopted; in many cases the ultimate origin of the expression is to be found in a different language; "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("odalisque,")]), _vm._v(" for instance, is listed as French, though its ultimate origin is to be found in Turkish. Greek and Latin are Usted together as ‘Classical’, for reasons which will become apparent below, "), _c('a', {
    attrs: {
      "href": "#/xhtml/06_Introduction_1#page_40"
    }
  }, [_vm._v("pp. 40")]), _vm._v("–"), _c('a', {
    attrs: {
      "href": "#/xhtml/06_Introduction_1#page_42"
    }
  }, [_vm._v("42")]), _vm._v(". The first fact which emerges from these figures is the general increase in the total for each century. This increase is in part to be accounted for by the fact that the table includes only words and phrases still current in English: the longer ago an expression was introduced from a foreign language, the more chance it has had of being anglicized, or of becoming obsolete. Nevertheless, it seems likely that the number of foreign words and phrases adopted into the language has in fact increased, even though this conjecture cannot be proved from the figures. The second fact is that the total number of words and phrases attributable to the eighteenth century is actually less than the number attributable to the seventeenth century; in other words, there is a setback in the general rate of increase at this point. Since there is no likelihood that expressions adopted in the eighteenth century were more readily anglicized or more rapidly became obsolete than those adopted in the seventeenth century, it would seem certain that the number adopted in the eighteenth century really was smaller. This phenomenon is probably to be explained by the linguistic purism of the eighteenth century, as exemplified by the abortive attempts early in the century to found an English Academy on the lines of the Académie Française, and by the great prestige attained by Johnson’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Dictionary")]), _vm._v(" (1755) as an arbiter of permissible usage. Much more surprising is the third fact, that the number of Classical words and phrases introduced during the eighteenth century is only about half "), _c('a', {
    attrs: {
      "id": "page_27"
    }
  }), _vm._v("the number adopted in either the preceding or the following century; the popular belief that eighteenth-century gentlemen heavily interlarded their conversation with Classical tags would seem to be unjustified.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container",
    attrs: {
      "id": "tab_I"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0036-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("TABLE I")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The same figures can also be expressed as percentages, and some further facts are more clearly revealed by this form of presentation. "), _c('a', {
    attrs: {
      "href": "#/xhtml/06_Introduction_1#tab_II"
    }
  }, [_vm._v("Table II")]), _vm._v(" shows the proportion of words and phrases from a given language, expressed as a percentage of the total of words and phrases adopted from all foreign languages during a given century. Since there is no serious likelihood of selective anglicization or selective obsolescence, these percentages will hardly be affected by the fact that the table includes only those words and phrases still in current use; they can be accepted as representative of the actual proportion of expressions adopted from each language during a given century. The most striking feature of this table is the steady decline in the proportion of Classical words and phrases, from 78 per cent in the Middle Ages down to 13 per cent in the twentieth century. This decline is counterbalanced by an almost equally steady rise in the proportion of French words and phrases; there is a small drop in the sixteenth century, but apart from this the proportion rises steadily from a mere 16 per cent in the Middle Ages to over 50 per cent in the nineteenth and twentieth centuries. Italian words and phrases show a steady proportion of 6 to 8 per cent from the sixteenth to the twentieth century, except for a sudden peak of 15 per cent in the eighteenth century; this peak is certainly to be attributed to the large number of technical terms of art and music adopted during that period. Borrowings from German represent less than 1 per cent of the total from the sixteenth to the eighteenth century, but rise to 4 per cent in the nineteenth and to nearly 13 per cent in the twentieth century; this latter high proportion is attributable to the effect of two successive world wars.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container",
    attrs: {
      "id": "tab_II"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0037-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("TABLE II")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_28"
    }
  }), _vm._v("The figures of "), _c('a', {
    attrs: {
      "href": "#/xhtml/06_Introduction_1#tab_I"
    }
  }, [_vm._v("Table I")]), _vm._v(" can also be expressed as cumulative totals, which show the total number of words and phrases from a given language still in use at a given period—still with the proviso that words and phrases not in current use are excluded. "), _c('a', {
    attrs: {
      "href": "#/xhtml/06_Introduction_1#tab_III"
    }
  }, [_vm._v("Table III")]), _vm._v(" gives such cumulative totals. The effect of the limitation to words and phrases still in current use can again be eliminated by the use of percentages, and "), _c('a', {
    attrs: {
      "href": "#/xhtml/06_Introduction_1#tab_IV"
    }
  }, [_vm._v("Table IV")]), _vm._v(" gives the cumulative totals of "), _c('a', {
    attrs: {
      "href": "#/xhtml/06_Introduction_1#tab_III"
    }
  }, [_vm._v("Table III")]), _vm._v(" expressed as percentages of the whole in any given century. The Classical languages show the same steady decline, and French shows the same steady increase (apart from the slight drop in the sixteenth century); but these percentages enable us to see that it was not until about 1800 that the proportion of French words and phrases in use actually exceeded the proportion from the Classical languages. At the present day very nearly half the ‘foreign’ words and phrases in current use are from French; but more than a quarter are from the Classical languages; all the other languages put together only account for a little less than a quarter of the total.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container",
    attrs: {
      "id": "tab_III"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0038-1.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("TABLE III")])]), _vm._v(" "), _c('div', {
    staticClass: "img_container",
    attrs: {
      "id": "tab_IV"
    }
  }, [_c('img', {
    attrs: {
      "alt": "Images",
      "src": "images/f0038-2.jpg"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "cap"
  }, [_vm._v("TABLE IV")])]), _vm._v(" "), _c('h4', {
    staticClass: "head2",
    attrs: {
      "id": "id15"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_29"
    }
  }), _vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE HISTORICAL SIGNIFICANCE OF")]), _vm._v(" ‘"), _c('span', {
    staticClass: "small"
  }, [_vm._v("FOREIGN")]), _vm._v("’ "), _c('span', {
    staticClass: "small"
  }, [_vm._v("EXPRESSIONS")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Interesting though these figures are, the study of the actual lists of words and phrases in the Appendix is even more rewarding; there is much enlightenment here for the student of social history. The gradual extension of the number of languages drawn upon illustrates the expansion of the known world between the Middle Ages and the present day. During the Middle Ages only six languages contributed words and phrases to English: French, which until the end of the period was still much used in polite conversation; the learned languages Latin, Greek and Arabic; and two Celtic languages spoken in the British Isles—Gaelic and Irish. Nine more were added in the sixteenth century: the more important European languages, Italian and Spanish (strongly represented), German, Dutch and Portuguese (only sparsely represented); two languages extending beyond the borders of Europe, Russian and Turkish; and two Oriental languages, Hindustani and Malay. The seventeenth century saw the advent of some of the less important European languages, Danish, Norwegian and Welsh; two more learned languages, Hebrew and Sanskrit; and a larger number of Oriental languages—Persian, Chinese and Japanese, Tamil and Tibetan. The eighteenth century saw the introduction of only two new languages, Australian and Eskimo. In the nineteenth century were added one more European language, Magyar, and a number of languages from distant continents—Afrikaans, Swahili, Javanese, Hawaiian and Maori. So far the twentieth century has seen the addition of only one language hitherto unrepresented, Swedish; and it is doubtless a historical accident that no Swedish words have entered the language at an earlier date. In addition to the languages listed above there are about a score of languages which have contributed to English only one word each, at various dates from the seventeenth century onwards.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A study of the individual words and phrases contributed by the various languages yields only uneven results: sometimes a clear pattern emerges, sometimes not—French, for instance, has contributed so much more liberally than any other language that expressions of every possible type are to be found among the borrowings of each century. Expressions from Latin and Greek are, as might be expected, nearly all of a ‘learned’ type—technical expressions from the more sedate arts and sciences, and quotations from literary texts. A conspicuous feature of the Latin borrowings is the high proportion of phrases introduced from the earliest period; among the borrowings from other languages phrases tend to be rather rare until comparatively recent times. Latin expressions introduced during the "), _c('a', {
    attrs: {
      "id": "page_30"
    }
  }), _vm._v("Middle Ages include, as is natural, a large proportion of terms connected with religion; but Latin religious terms disappear almost completely between the Reformation in the early sixteenth century and the restoration of the Roman hierarchy in 1850, after which they again become plentiful. During the intervening period ‘foreign’ religious terms are nearly all from Italian: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("biretta, nuncio, padre")]), _vm._v(" (sixteenth century); "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("baldacchino, monsignore")]), _vm._v(" (seventeenth century); "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("beato, campo santo, zucchetto")]), _vm._v(" (nineteenth century); the complete absence of Italian religious terms in the eighteenth century is perhaps counterbalanced by the occurrence of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("abbé")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("prie-dieu")]), _vm._v(" from French.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The vast majority of words and phrases from Italian are connected either with music or with the plastic arts. Expressions connected with architecture and painting have entered English in a steady flow since the sixteenth century; in the eighteenth century there was a sudden cataract of expressions connected with music; since that time musical terms have continued to be introduced, but recently there has been a renewed rise in the number of terms connected with architecture and painting. Expressions from German are negligibly few until the nineteenth century, and nineteenth-century borrowings are mostly of the kind brought back by English tourists: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Alpenstock, Edelweiss, Gasthof, Kursaal, Pretzel, Schloss,")]), _vm._v(" and so on. More recent introductions from German reflect only too clearly the most conspicuous features of German history during the twentieth century, totalitarian rule and the two successive wars resulting from it. Various aspects and consequences of dictatorship are illustrated by "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Führerprinzip, Gleichschaltung, Judenhetze, Lebensraum, Machtübernahme, Putsch, Realpolitik, Totschläger, Vernichtungslager,")]), _vm._v(" and many others; the two wars have contributed "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Blitzkrieg, Ersatz, Feldgrau, Festung Europa, Flammenwerfer, Kriegsgefangene(r), Minenwerfer, Panzer, Schnorchel, Schrecklichkeit,")]), _vm._v(" and others. A study of the expressions introduced from other languages can be equally rewarding—the borrowings from Hindustani, for instance, illustrate the rise and fall of the East India Company and the eventual withdrawal of the British from India—but space does not permit a full analysis; however, the materials for such a study are given in full in the Appendix to the dictionary.")]), _vm._v(" "), _c('h4', {
    staticClass: "head2",
    attrs: {
      "id": "id16"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE ORIGINS OF QUOTATIONS")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Many of the ‘foreign’ phrases used in English are quotations, and it is of some interest to examine the sources from which they are drawn. The first striking point is the high proportion of quotations "), _c('a', {
    attrs: {
      "id": "page_31"
    }
  }), _vm._v("which have been adapted or altered in some way. Only rarely does the alteration seem to be stylistic: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("nihil tetigit quod non ornavit")]), _vm._v(" seems a clear improvement on the original "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("nullum quod tetigit non ornavit")]), _vm._v(" (Dr Johnson); "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("c’est pire qu’un crime, c’est une faute")]), _vm._v(" is more forceful than the original "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("c’est plus qu’un crime …")]), _vm._v(" (Fouché). Nearly all the altered quotations are from Latin, and there is a special reason for this. The majority of Latin quotations are from sources in verse, and Latin poetic style often results in the wide separation of closely related words; if the words to be quoted are thus separated, the intervening words have to be left out. Thus, Horace’s")]), _vm._v(" "), _c('div', {
    staticClass: "ext"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Æquam")]), _vm._v(" memento rebus in arduis")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Servare mentem")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("is quoted as "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("æquam servare mentem,")]), _vm._v(" and Juvenal’s")]), _vm._v(" "), _c('div', {
    staticClass: "ext"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Da")]), _vm._v(" spatium vitæ, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("multos")]), _vm._v(" da, Jupiter, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("annos")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("as "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("da multos annos.")]), _vm._v(" Sometimes the order of the words is altered too: thus, Horace’s")]), _vm._v(" "), _c('div', {
    staticClass: "ext"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Iile "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("terrarum")]), _vm._v(" mihi præter omnis")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Angulus")]), _vm._v(" ridet")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("is quoted as "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("angulus terrarum,")]), _vm._v(" and Virgil’s")]), _vm._v(" "), _c('div', {
    staticClass: "ext"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("fugit")]), _vm._v(" irreparabile "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("tempus")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("as "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("tempus fugit.")]), _vm._v(" Moreover, the requirements of Latin syntax sometimes lead to the appearance of a quotable phrase in an inappropriate case. Thus, Horace’s")]), _vm._v(" "), _c('div', {
    staticClass: "ext"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Auream")]), _vm._v(" quisquís "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("mediocritatem")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Diligit …")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("is quoted as "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("aurea mediocritas")]), _vm._v(" in the nominative, and Sallust’s")]), _vm._v(" "), _c('div', {
    staticClass: "ext"
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("Appius ait, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("fabrum")]), _vm._v(" esse "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("suæ")]), _vm._v(" quemque "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("fortume")])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("as "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("faber fortume suæ.")]), _vm._v(" This latter example is particularly interesting, since although the original is in prose the quoted form has been altered in three ways: intervening words have been omitted, the order of the words has been transposed, and the case has been changed. (There are a few instances in which an inappropriate case is retained in English usage: Juvenal’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("panem et circenses")]), _vm._v(" is always quoted in the accusative, irrespective of the English syntax; the verb required to govern the accusative in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ex ungue leonem")]), _vm._v(" and its congener "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ex pede Herculem")]), _vm._v(" is never expressed, though it is present in the Greek phrase from which the former is translated.) Sometimes the alteration of "), _c('a', {
    attrs: {
      "id": "page_32"
    }
  }), _vm._v("case may result in a different meaning from that of the original: Horace’s "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("disjecti membra poetæ")]), _vm._v(" ‘the limbs of a dismembered poet’ is always quoted in the form "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("disjecta membra")]), _vm._v(" ‘dismembered limbs’, and applied to fragmentary literary remains.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Latin quotations heavily outnumber those from foreign languages. Among the quotations included in this dictionary 161 are from Latin, compared with forty-eight from French, eight from German, and four from Italian. The majority of the Latin quotations are drawn from a few favourite authors. At the head of the list is Horace, with thirty-two quotations in all, eighteen from the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Odes,")]), _vm._v(" five from the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Satires,")]), _vm._v(" five from the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Ars Poetica,")]), _vm._v(" and four from the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Epistles.")]), _vm._v(" Rather surprisingly, the next in order of frequency is the Vulgate version of the Bible, from which no less than twenty-nine quotations are drawn; the substantial contribution made by the Vulgate to the stock of phrases used in English is usually overlooked. Next comes Virgil, with twenty-one quotations in all, sixteen from the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Æneid,")]), _vm._v(" three from the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Georgies,")]), _vm._v(" and two from the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Eclogues;")]), _vm._v(" then Cicero with fourteen quotations, Juvenal with nine, Suetonius with seven, Ovid with six, and Tacitus with four. No other writer contributes more than three quotations, but few writers of the Golden or Silver Age are not represented by at least one quotation.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The quotations from French follow quite a different pattern. The forty-eight French quotations are drawn from thirty-seven different writers, and only six writers are represented by more than one quotation: Molière with five, Voltaire with four, Balzac, Diderot, Dumas and Proust with two each. Many of the writers represented are relatively unknown: no one but a student of French literature is likely to have heard of Émile Augier ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("nostalgie de la boue),")]), _vm._v(" Edmond Harancourt ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("partir, c’est mourir un peu),")]), _vm._v(" Jouvenot and Micard ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("fin de siècle),")]), _vm._v(" or Alphonse Karr ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("plus ça change, plus c’est la même chose).")]), _vm._v(" Another oddity of the French quotations is the fact that a high proportion of them are taken, not from the text of a work, but from its title. The following represent no more than a selection of such quotations: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("demi-monde")]), _vm._v(" (Dumas), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("demi-vierge")]), _vm._v(" (Prévost), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("démon de midi")]), _vm._v(" (Bourget), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("embarras des richesses")]), _vm._v(" (d’Allainval), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("femme de trente ans")]), _vm._v(" (Balzac), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("femme savante")]), _vm._v(" (Molière), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("poète maudit")]), _vm._v(" (Verlaine), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("princesse lointaine")]), _vm._v(" (Rostand), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("saison en enfer")]), _vm._v(" (Rimbaud), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("trahison des clercs")]), _vm._v(" (Benda), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("vie de Bohème")]), _vm._v(" (Murger). Among the eight German quotations there is only one duplication of origin: both "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Blut und Eisen")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Eisen und Blut")]), _vm._v(" were used by Bismark, on different occasions. Of the four Italian quotations three, as one might expect, are from Dante; the fourth, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("se non è vero è molto ben trovato,")]), _vm._v(" was used by Giordano Bruno but may already have been proverbial.")]), _vm._v(" "), _c('h3', {
    staticClass: "head1",
    attrs: {
      "id": "id17"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_33"
    }
  }), _c('span', {
    staticClass: "bold"
  }, [_vm._v("II. The Use and Abuse of ‘Foreign’ Words and Phrases")])]), _vm._v(" "), _c('h4', {
    staticClass: "head2",
    attrs: {
      "id": "id18"
    }
  }, [_vm._v("‘D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ESCRIPTION")]), _vm._v("’ "), _c('span', {
    staticClass: "small"
  }, [_vm._v("AND")]), _vm._v(" ‘"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PRESCRIPTION")]), _vm._v("’")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The functions of the lexicographer, as of the grammarian, are traditionally two-fold—to describe and to prescribe; that is, he must record all the variations of usage which in fact exist, and at the same time point out which usages are more and which less desirable. It is the fashion at present to decry prescription in grammar and lexicography, and to insist that both should be purely descriptive. Since any language—so runs the argument—is no more than the sum total of the usage of those who speak and write it, the only possible criterion of ‘correctness’ is usage; hence the only legitimate function of the grammarian and lexicographer is to record and systematize the facts of current usage. The argument is not wholly without substance, and it is certainly difficult to defend the procedure of certain grammarians in the past who were so much misled by their pre-occupation with Latin grammar that the rules they laid down prescribed usages which not only were not, but never had been, current English. Nevertheless, the argument in its extreme form overlooks two important facts.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the first place, usage is never uniform; different classes of speakers and writers will differ substantially in their modes of expressing ideas, and even within the usage of a single speaker or writer there is often room for variation according to the occasion of the utterance, or even according to mood or whim. In the second place, the primary function of language is communication, so that clarity and intelligibility are qualities without which language cannot fulfil its purpose. If for the expression of any idea there is only one current turn of phrase, and this is lacking in clarity and intelligibility, obviously nothing can be done about it—the deficiency must be regretfully accepted. But if, as is more commonly the case, there is more than one turn of phrase available, equally obviously the one which is superior in clarity and intelligibility must be preferred to the others; and it is not only the right but the duty of the grammarian and lexicographer to point out which of a number of concurrent usages is to be preferred on such grounds. It is not possible to evade this issue. If, for instance, we choose to prefer the usage of one set of speakers to that of another, the evasion is only apparent, not real, since the set of speakers chosen as the standard will inevitably be those whose usage is preferable on grounds of clarity and intelligibility.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_34"
    }
  }), _vm._v("The compiler of a dictionary of ‘foreign’ words and phrases must, of course, record all the words and phrases which are in fact in current use, together with all the important variations in spelling and pronunciation which in fact occur; but he cannot well avoid the task of discussing ‘correctness’ in the use of such words and phrases. He must first of all consider the question whether there are any expressions amongst those which he lists which ought either not to be used at all in English, or to be used only in certain well-defined circumstances; in discussing this question he must be guided by the principles governing the use of language in general. Secondly, granted that certain ‘foreign’ words and phrases may be used (at least on certain occasions), he must consider the question of ‘correctness’ in the spelling and pronunciation of these expressions, and in the use of foreign feminine and plural forms. In this second task he must take into account not only general principles, but also the usage in the various languages from which the ‘foreign’ expressions have come. This is not to say, of course, that where English usage is in question the usage of a foreign language can ever be decisive; we have already seen ("), _c('a', {
    attrs: {
      "href": "#/xhtml/05_Introduction#page_11"
    }
  }, [_vm._v("pp. 11")]), _vm._v("–"), _c('a', {
    attrs: {
      "href": "#/xhtml/05_Introduction#page_13"
    }
  }, [_vm._v("13")]), _vm._v(") that the spelling of a foreign word may be altered in English (often for very good reasons), and that the meaning, too, may undergo change. Nevertheless, usage in the language of origin cannot be entirely neglected; such aberrations, for instance, as the spurious plural "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("apparati")]), _vm._v(" are due merely to ignorance; and every departure from the usage of the language of origin must be carefully considered on its merits.")]), _vm._v(" "), _c('h4', {
    staticClass: "head2",
    attrs: {
      "id": "id19"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE USE OF")]), _vm._v(" ‘"), _c('span', {
    staticClass: "small"
  }, [_vm._v("FOREIGN")]), _vm._v("’ "), _c('span', {
    staticClass: "small"
  }, [_vm._v("EXPRESSIONS")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Any objection to the use of ‘foreign’ words and phrases as such, or to any class of them in particular, must be based on the principle that the primary function of language is communication. The use of any expression or turn of phrase, whether English or ‘foreign’, ought to be limited by two considerations: that the expression used is the most apt to express the meaning intended; and that it should be immediately intelligible to the reader or listener envisaged. It might be thought that if all speakers and writers were conscientious there would be no need for a dictionary such as this. However, even the most conscientious writer can only consider the needs of one class of readers, the class he considers most likely to be interested in his work; and he is not to be blamed if his work falls into the hands of another class of readers who do not find his modes of expression so readily intelligible. Thus, the writer on technical or quasi-technical subjects is fully entitled to make use of technical words and expressions not "), _c('a', {
    attrs: {
      "id": "page_35"
    }
  }), _vm._v("easily intelligible to the uninitiated; so that the cultivated reader who takes a general interest in subjects in which he has no "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("expertise—")]), _vm._v("the reader who, though not a lawyer, enjoys the law reports, or the reader who, though not a musician, follows the accounts of recent concerts, and so on—is likely to encounter technical words and expressions, used in all good faith by the writer, which he does not understand. The speaker is in rather a different position from the writer. Unlike the writer, the speaker can normally see the people who are listening to him and can moderate his modes of expression accordingly. However, even the speaker may in certain circumstances be unable to judge with any accuracy the range of understanding of those who are listening. The lecturer addressing an unfamiliar audience, even the casual speaker talking in a group not all the members of which are known to him—these may in all good faith use expressions which are not readily intelligible. Hence, even if all writers and speakers were conscientious there would still be a need for a dictionary of ‘foreign’ expressions; and moreover there are many writers and speakers who use ‘foreign’ expressions for quite illegitimate purposes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The use of ‘foreign’ expressions is justified only if there is no English equivalent (or no adequate English equivalent), and if the expression in question is likely to be understood without difficulty by all probable readers or listeners. It follows that the legitimacy of the use of these expressions will depend almost wholly on the occasion of the utterance. A speaker conversing on general matters in mixed company, a writer discussing a general topic in a book or article likely to be read by all and sundry—these should be careful to use only those non-technical ‘foreign’ expressions which have achieved wide currency because there is no true equivalent in English. The writer or lecturer on technical subjects, addressing an audience of like-minded enthusiasts, is naturally free to make extensive use of the accepted technical terms of his subject, even if they are ‘foreign’; even so, he should first make sure that there is no acceptable English equivalent. Similarly, the writer or speaker who has to deal with the institutions and customs of foreign countries is entitled to make use of ‘foreign’ expressions to describe them, provided that by so doing he can save time without loss of clarity. The validity of the use of ‘foreign’ expressions merely to provide local colour is more questionable; it is difficult not to feel that a really competent speaker or writer ought to be able to achieve the effect he requires by suitably manipulating the extensive resources of his proper medium, the English language.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("But the use of ‘foreign’ expressions for their own sake is altogether a different matter. To use an expression merely because it is ‘foreign’, not because it expresses the required meaning better than any available "), _c('a', {
    attrs: {
      "id": "page_36"
    }
  }), _vm._v("English equivalent; to use a ‘foreign’ expression not in the confidence that it will be perfectly intelligible to the reader or listener, but in the hope that it will not: this is to display a peculiarly unpleasant type of intellectual arrogance and snobbery"), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Introduction_2#A17",
      "id": "B17"
    }
  }, [_vm._v("1")])]), _vm._v(". It is not too difficult to forgive a writer who is genuinely so well versed in a foreign language that an expression from that language springs to his mind as readily as an English one; it is a very human faffing to use such a ‘foreign’ expression for decorative purposes without pausing to consider whether it will be readily intelligible to one’s readers. If, on the other hand, a writer racks his brains to think up a ‘foreign’ equivalent for the English expression which springs naturally to his mind; if (still worse) he hunts through a dictionary such as this to find a ‘foreign’ expression that can somehow be dragged in to what he is writing, in order to convey to his readers that his command of foreign languages is better than it really is, or to pretend to a profound knowledge of foreign languages which does not really exist—this is not only deceitful, it is prostituting the function of language to unworthy purposes.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It follows from all this that a dictionary of ‘foreign’ words and phrases differs from all other dictionaries in so far as it should be, as it were, a ‘one-way’ dictionary: it is for the use of readers, not of writers; of listeners, not of speakers. If a writer or a speaker has occasion to consult such a dictionary, even to check some minor point of spelling or pronunciation, or some shade of meaning, the word or phrase he is looking up cannot have sprung so naturally to his mind that he is justified in using it; the mere fact that he has looked an expression up in the dictionary should debar him from using it. One result of this peculiarity is that the definitions in such a dictionary can often be simplified or compressed: they are intended to throw light on an expression already standing in a context, not to delimit the kind of context into which an expression may be placed. This point is illustrated more fully below, "), _c('a', {
    attrs: {
      "href": "#/xhtml/07_Introduction_2#page_59"
    }
  }, [_vm._v("p. 59")]), _vm._v(".")]), _vm._v(" "), _c('h4', {
    staticClass: "head2",
    attrs: {
      "id": "id20"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE PRONUNCIATION AND SPELLING OF")]), _vm._v(" ‘"), _c('span', {
    staticClass: "small"
  }, [_vm._v("FOREIGN")]), _vm._v("’ "), _c('span', {
    staticClass: "small"
  }, [_vm._v("EXPRESSIONS")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Granted that in certain circumstances it is permissible to use ‘foreign’ words and phrases in an English context, certain problems arise in connection with their spelling and pronunciation. The problems vary from language to language, and it will be convenient to divide foreign languages into three main groups: the Classical languages, Latin and Greek; languages written in scripts or alphabets other than the Roman alphabet; and European languages written in the Roman "), _c('a', {
    attrs: {
      "id": "page_37"
    }
  }), _vm._v("alphabet. European languages can be further divided into two subgroups: those (like French, German and Italian) of which a large number of cultivated people have some knowledge, and those (like, for instance, the Scandinavian languages) which are known to comparatively few. The most difficult problems are presented by the Classical languages, Latin and Greek, and these must be discussed first.")]), _vm._v(" "), _c('h4', {
    staticClass: "head2",
    attrs: {
      "id": "id21"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE PRONUNCIATION AND SPELLING OF")]), _vm._v(" L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ATIN")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("There are no less than three different pronunciations of Latin current in England at the present day, each with its own appropriate peculiarities of spelling.")]), _vm._v(" "), _c('p', {
    staticClass: "indent5"
  }, [_vm._v("(1) "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The traditional or ‘English’ pronunciation.")]), _vm._v(" This system, in which both vowels and consonants are pronounced as in English, is the historical descendant of the pronunciation used in England during the Middle Ages. In the Middle Ages the association of sound with alphabetic symbol differed little from language to language, so that although each nation pronounced Latin with the sounds of its own language, Latin could be used as a medium of communication from one end of Europe to the other. But whereas the vowels of most other European languages have not altered much since the Middle Ages, the English vowels during the period 1400–1700 underwent an extensive series of changes collectively known as the ‘Great Vowel Shift’, as a result of which the vowel-symbols acquired their present values, very different from those represented by the same symbols in other languages"), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Introduction_2#A18",
      "id": "B18"
    }
  }, [_vm._v("1")])]), _vm._v("; and, as the vowels of English changed, so the vowels of Latin (as spoken in England) changed with them. This ‘English’ pronunciation is no longer used when Latin is read aloud, except for certain formal purposes in the older universities; but it is the only acceptable pronunciation for the numerous Latin terms and phrases used by lawyers, and remains the normal pronunciation for the great majority of other Latin words and phrases used in English. Certain peculiarities of spelling are appropriate to this pronunciation: ‘consonant "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("i’")]), _vm._v(" and ‘consonant "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("u’")]), _vm._v(" are written "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("j")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("v")]), _vm._v(" respectively (as they must be, since they are pronounced like English "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("j")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("v),")]), _vm._v(" and the original diphthongs "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ae")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("oe")]), _vm._v(" are written "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("æ")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("œ")]), _vm._v(" respectively (both are pronounced like English "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ee).")]), _vm._v(" There has been some confusion between "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("æ")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("e,")]), _vm._v(" so that "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("et cetera")]), _vm._v(" is much commoner than "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("et cætera,")]), _vm._v(" "), _c('a', {
    attrs: {
      "id": "page_38"
    }
  }), _vm._v("and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ceteris paribus")]), _vm._v(" is at least as common as "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("cæteris paribus;")]), _vm._v(" the two distinct words "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("cæstus")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("cestus")]), _vm._v(" are regularly confused in spelling. Confusion between "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("œ")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("e")]), _vm._v(" is much less frequent, but the spelling "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("fœtus")]), _vm._v(" has completely ousted the historical "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("fetus.")]), _vm._v(" Until comparatively recently certain accent-marks were used in writing and printing Latin tags pronounced in the ‘English’ way, the grave accent to indicate that final "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("-e")]), _vm._v(" is syllabic, not (as usually in English words) silent, and the circumflex to distinguish the ablative singular of the first declension from the nominative singular; both usages are illustrated in the phrases "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("bona fidè")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("vicè versa.")]), _vm._v(" It is to be regretted that this useful custom has now been given up.")]), _vm._v(" "), _c('p', {
    staticClass: "indent5"
  }, [_vm._v("(2) "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The ecclesiastical or ‘Italian’ pronunciation.")]), _vm._v(" This system, in which both vowels and consonants are pronounced approximately as in Italian, was introduced into England at the time of the restoration of the Roman hierarchy in 1850, and has since been adopted by many Anglican clergy of High Church inclinations"), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Introduction_2#A19",
      "id": "B19"
    }
  }, [_vm._v("1")])]), _vm._v(". This pronunciation is appropriate to the fairly numerous words and phrases of ecclesiastical connotation. The spelling appropriate to this system is the same as that appropriate to the ‘English’ system, though "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("j")]), _vm._v(" is pronounced like English "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("y,")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("æ")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("œ")]), _vm._v(" are pronounced like Italian "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("e.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent5"
  }, [_vm._v("(3) "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The reformed or ‘Classical’ pronunciation.")]), _vm._v(" This system—a reconstruction of the pronunciation used in Rome during the Golden Age of Latin literature—was introduced into English schools about 1900, and is now (with some modifications) used almost universally for pædagogic purposes. In this system the vowels are pronounced as in Italian; the diphthongs "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("æ")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("œ")]), _vm._v(" (always so written) are pronounced with the diphthongs of English "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("by")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("boy")]), _vm._v("; ‘consonant "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("i’")]), _vm._v(" (written z) and ‘consonant "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("u’")]), _vm._v(" (written "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("u")]), _vm._v(") are pronounced like English "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("y")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("w")]), _vm._v(" respectively; "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("c")]), _vm._v(" is always pronounced like English "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("k, g")]), _vm._v(" always like English "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("g")]), _vm._v(" in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("got,")]), _vm._v(" even before a following "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("e")]), _vm._v(" or "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("i")]), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Introduction_2#A20",
      "id": "B20"
    }
  }, [_vm._v("2")])]), _vm._v(". There is little doubt that this ‘Classical’ pronunciation reproduces with considerable "), _c('a', {
    attrs: {
      "id": "page_39"
    }
  }), _vm._v("accuracy that current in Rome at the beginning of the Christian era; whether it is the ideal pronunciation to use in the teaching of Latin is another question, which it is fortunately unnecessary to discuss here. Suffice it to say that the ‘Classical’ pronunciation in its pure form is never used for Latin words and phrases in an English context—he would be a bold man who would write "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ueni, uidi, uici")]), _vm._v(" and pronounce it with the appropriate "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("w-")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("k")]), _vm._v("-sounds; but some of its features have influenced the pronunciation of the longer and less frequently used phrases.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The majority of Latin words and phrases are currently pronounced according to the ‘English’ system of pronunciation"), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Introduction_2#A21",
      "id": "B21"
    }
  }, [_vm._v("1")])]), _vm._v(". Words and phrases of ecclesiastical connotation are usually pronounced according to the ‘Italian’ pronunciation, though there are some curious anomalies here. In such expressions as "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Agnus Dei")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Magnificat")]), _vm._v(" the combination "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("gn")]), _vm._v(" should, in the ‘Italian’ pronunciation, be pronounced as in Italian (that is, approximately like "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ni")]), _vm._v(" in English "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("onion);")]), _vm._v(" in the ‘Classical’ pronunciation like English "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ng")]), _vm._v(" followed by "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("n;")]), _vm._v(" in the ‘English’ pronunciation like English "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("g")]), _vm._v(" followed by "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("n.")]), _vm._v(" In fact the ‘English’ pronunciation of the combination "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("gn")]), _vm._v(" is always used in these expressions, so that in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Agnus Dei")]), _vm._v(" the first word is pronounced with the ‘English’ pronunciation and the second with the ‘Italian’. However, the real difficulty arises with the longer Latin phrases, particularly those which can be recognized as quotations from well-known writers. Until about 1900 these were certainly pronounced according to the ‘English’ pronunciation, since this pronunciation was used in the study of Latin literature; now the conflict of pronunciations has led to uncertainty. The speaker who will refer without hesitation to a ‘decree "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("nisi’,")]), _vm._v(" making "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("nisi")]), _vm._v(" rhyme with English "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("I sigh,")]), _vm._v(" will hesitate to use the same pronunciation in the phrase "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("de mortuis nil nisi bonum;")]), _vm._v(" and the most convinced exponent of the ‘Classical’ pronunciation, when quoting the phrase "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("aut Cæsar aut nullus,")]), _vm._v(" will hesitate to pronounce the familiar "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Cæsar")]), _vm._v(" like German "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Kaiser.")]), _vm._v(" This doubt about the appropriate pronunciation leads to an avoidance of the longer phrases and quotations, and to a lack of uniformity of pronunciation when they are used. Doubtless the ‘English’ pronunciation is the most appropriate for any Latin phrase or quotation used in an English context; but, though the pronunciation of most of the more frequent words and tags is familiar through constant use, the ‘English’ version of the longer phrases may be unknown, or accessible only after some thought; and the fear of "), _c('a', {
    attrs: {
      "id": "page_40"
    }
  }), _vm._v("seeming eccentric may also hinder its use. In so far as it is possible to generalize for these difficult cases, there seems to be a tendency to combine ‘Classical’ vowels with ‘English’ consonants.")]), _vm._v(" "), _c('h4', {
    staticClass: "head2",
    attrs: {
      "id": "id22"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE SPELLING OF")]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REEK")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The transliteration of the Greek alphabet by the Romans differs in some respects from the transliteration now considered to represent the Greek sounds best. The following are the symbols and combinations of symbols for which the transliterations differ:")]), _vm._v(" "), _c('table', {
    staticClass: "tab1"
  }, [_c('tbody', [_c('tr', [_c('td', [_c('p', {
    staticClass: "ttext"
  }, [_vm._v("υ")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "ttext"
  }, [_vm._v("u")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "ttext"
  }, [_vm._v("y")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "ttext"
  }, [_vm._v("∊ι")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "ttext"
  }, [_vm._v("ei")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "ttext"
  }, [_vm._v("ī")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "ttext"
  }, [_vm._v("ου")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "ttext"
  }, [_vm._v("ou")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "ttext"
  }, [_vm._v("ū")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "ttext"
  }, [_vm._v("αι")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "ttext"
  }, [_vm._v("ai")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "ttext"
  }, [_vm._v("æ")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "ttext"
  }, [_vm._v("οι")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "ttext"
  }, [_vm._v("oi")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "ttext"
  }, [_vm._v("œ")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "ttext"
  }, [_vm._v("κ")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "ttext"
  }, [_vm._v("k")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "ttext"
  }, [_vm._v("c")])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "ttext"
  }, [_vm._v("χ")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "ttext"
  }, [_vm._v("kh")])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "ttext"
  }, [_vm._v("ch")])])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The first column shows the Greek symbols, the second the accepted modern transliteration, the third the Roman transliteration"), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Introduction_2#A22",
      "id": "B22"
    }
  }, [_vm._v("1")])]), _vm._v(". In addition, the Romans adapted the endings of many of the Greek declensions to conform with their own Latin declensions: in particular, the masculine ending -"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("oς")]), _vm._v(" (-"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("os")]), _vm._v(") becomes -"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("us")]), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Introduction_2#A23",
      "id": "B23"
    }
  }, [_vm._v("2")])]), _vm._v(", the neuter ending "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("-ov (-on")]), _vm._v(") becomes "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("-um,")]), _vm._v(" and the feminine ending "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("-η (-ē")]), _vm._v(") becomes "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("-a.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("It would seem to be a simple matter to decide whether a given word entered English through Latin or direct from Greek by observing its form: words which show the Roman transliteration and the Latin endings must have come through Latin, those which show the modern transliteration and the Greek endings must have come direct from Greek. Unfortunately the problem is not nearly so simple as it looks. In the first place, later Latin did not always substitute its own inflectional endings for those of Greek; in particular, the neuter ending "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("-on")]), _vm._v(" often survives"), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Introduction_2#A24",
      "id": "B24"
    }
  }, [_vm._v("3")])]), _vm._v(". In the second place, the Roman method of "), _c('a', {
    attrs: {
      "id": "page_41"
    }
  }), _vm._v("transliteration became so familiar (because of the numerous Greek words that have entered English through Latin) that until very recently it was often used in preference to the modern system, even in rendering Greek words which have never been adopted into Latin. The Roman system was used almost without exception until the nineteenth century, though the Greek inflectional endings were often preserved, as in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("cosmos.")]), _vm._v(" Apparent exceptions like "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("boustrophedon, hoi polloi,")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("nous")]), _vm._v(" (all introduced during the seventeenth century) were until recently always written or printed in Greek characters, even in an English context, so that their transliteration is quite modern; another apparent exception is "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("peripeteia,")]), _vm._v(" which has recently replaced an earlier "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("peripetia")]), _vm._v(" transliterated according to the Roman system. Even when the Roman system began to be abandoned, the modern system was not adopted in its entirety to replace it; there are many instances of compromise, due to dislike of the appearance of certain combinations in English. Thus, though the representation of the Greek diphthongs by "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ei, ou, ai")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("oi")]), _vm._v(" has been normal since the last century"), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Introduction_2#A25",
      "id": "B25"
    }
  }, [_vm._v("1")])]), _vm._v(" in such forms as "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("eidolon, parousia, korai")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("koine,")]), _vm._v(" the use of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("u")]), _vm._v(" instead of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("y")]), _vm._v(" is rare ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("hubris")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("kudos")]), _vm._v(" are the only examples); "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("k")]), _vm._v(" instead of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("c")]), _vm._v(" is often avoided (as in the twentieth-century borrowing "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("catharsis")]), _vm._v(")"), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Introduction_2#A26",
      "id": "B26"
    }
  }, [_vm._v("2")])]), _vm._v(", and there is no example in English of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("kh—")]), _vm._v("such forms as "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("kaf exochen")]), _vm._v(" (formerly written or printed in Greek characters and only recently transliterated), "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("encheiridion,")]), _vm._v(" and the nineteenth century "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("chiton")]), _vm._v(" all use "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ch,")]), _vm._v(" though the first has the modern "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("k")]), _vm._v(" and the second the modern "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ei.")]), _vm._v(" The history of the word now written "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ankylosis")]), _vm._v(" is enlightening. This word was first introduced in the eighteenth century in the Roman transliteration "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ancylosis;")]), _vm._v(" then, since such a spelling might lead the unwary to pronounce the "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("c")]), _vm._v(" as "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("s,")]), _vm._v(" it was soon replaced by "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("anchylosis")]), _vm._v(" with a "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ch")]), _vm._v(" that has no warrant in the Greek; it is only recently that "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("anchylosis")]), _vm._v(" has in turn given place to "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ankylosis,")]), _vm._v(" with modern "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("k")]), _vm._v(" but Roman "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("y.")]), _vm._v(" Other curious forms are the nineteenth-century "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ikon")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("kerygma,")]), _vm._v(" which also combine a modern consonant with a Roman vowel. Quite inexplicable is "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("eureka,")]), _vm._v(" which according to either system of transliteration ought to begin with an "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("h;")]), _vm._v(" the form "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("heureca")]), _vm._v(" was in use about 1600, but since 1650 "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("eureka")]), _vm._v(" has been the standard form, though "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("heureka")]), _vm._v(" occurs as an occasional pedantry.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("In the light of such inconsistencies it is impossible to determine from the form alone whether a given word came into English through "), _c('a', {
    attrs: {
      "id": "page_42"
    }
  }), _vm._v("Latín or directly from Greek; and there are, of course, a number of Greek words which would have the same form in either of the systems of transliteration, and which have inflectional endings (such as "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("-ις,")]), _vm._v(" Latin "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("-is")]), _vm._v(") which would not be altered in Latin. As a practical solution to the problem I have adopted the following principles: (1) if a word is transliterated according to the Roman system, and a corresponding form exists in Latin (even in modern Latin) I have assumed that it entered English through Latin; if there is no corresponding form in Latin I have assumed that it came direct from Greek; (2) if a word shows any single feature of the modern transliteration, even in combination with other features drawn from the Roman system, I have assumed that it came direct from Greek; (3) if a word would have the same form in either system of transliteration, I have arbitrarily assumed that it came direct from Greek, even if a corresponding form exists in Latin. These principles are sufficient to classify all but a few of the words of Greek origin; but one or two problems remain. The most puzzling is the word "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("amæba")]), _vm._v(" from Greek "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ἀμοιβή")]), _vm._v("; here the diphthong "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("οι")]), _vm._v(" appears as "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("œ")]), _vm._v(" according to the Roman system, and the ending "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("-η")]), _vm._v(" has been replaced by "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("-a;")]), _vm._v(" yet the word appears never to have been used in Latin, even in modern Latin. Since the inflectional endings are not normally altered in direct borrowings from the Greek, even when the Roman transliteration is used, I have felt bound to assume that the word has been used in modern Latin, but has escaped the notice of the lexicographers. Special difficulties are presented by pseudo-Greek words—that is, words which are based on Greek stems, but which have never actually existed in Greek. One such word is "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("telæsthesia,")]), _vm._v(" which despite its origin at the end of the nineteenth century uses the Roman transliteration "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("æ")]), _vm._v(" for "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("αι;")]), _vm._v(" another is "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("anonyma,")]), _vm._v(" which not only used the Roman "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("y for v,")]), _vm._v(" but has the Latin ending "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("-a.")]), _vm._v(" In view of these doubts and difficulties it has seemed preferable to class Greek and Latin words together in the statistical tables on "), _c('a', {
    attrs: {
      "href": "#/xhtml/06_Introduction_1#page_26"
    }
  }, [_vm._v("pp. 26")]), _vm._v("–"), _c('a', {
    attrs: {
      "href": "#/xhtml/06_Introduction_1#page_28"
    }
  }, [_vm._v("28")]), _vm._v(".")]), _vm._v(" "), _c('h4', {
    staticClass: "head2",
    attrs: {
      "id": "id23"
    }
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE PRONUNCIATION OF")]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("REEK")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The pronunciation of words of Greek origin presents as many difficulties as the pronunciation of Latin words, since once again three different systems are in use.")]), _vm._v(" "), _c('p', {
    staticClass: "indent5"
  }, [_vm._v("(1) "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The traditional pronunciation.")]), _vm._v(" This system has the same history as the traditional or ‘English’ pronunciation of Latin: it is the descendant of the pronunciation in use before the completion of the sound-changes which transformed the English vowels. It corresponds "), _c('a', {
    attrs: {
      "id": "page_43"
    }
  }), _vm._v("closely to the traditional pronunciation of Latin, and in the numerous cases where a Greek word appears in English in a Latin form the ‘English’ pronunciation is appropriate. Even some of the Greek words which appear in a modern transliteration follow the traditional pronunciation: thus, "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("nous")]), _vm._v(" rhymes with English "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("house,")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("hubris")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("kudos")]), _vm._v(" are pronounced with English "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("u")]), _vm._v(" as in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("due.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent5"
  }, [_vm._v("(2) "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The reformed pronunciation.")]), _vm._v(" This system purports to reproduce the pronunciation of ancient Greek, and is used for the teaching of Greek in schools"), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Introduction_2#A27",
      "id": "B27"
    }
  }, [_vm._v("1")])]), _vm._v(". It reproduces the ancient pronunciation much less accurately than the ‘Classical’ pronunciation of Latin: for instance, although there can be little doubt that in ancient Greek the characters "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("θ (th), ϕ (ph),")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("χ (kh")]), _vm._v(") were pronounced as aspirated stops (i.e. as in "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("pothook, taphouse")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("Lockheed")]), _vm._v(" respectively), no attempt is ever made to reproduce these difficult sounds. There is a special difficulty in finding the position of the stress in Greek words. The accent-marks now customarily used in writing and printing Greek were the invention of post-Classical grammarians in Alexandria; there is no reason to doubt the accuracy of the tradition they recorded, since in modern Greek the stress always falls on the syllable which bears the accent-mark"), _c('sup', {
    staticClass: "sup"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/07_Introduction_2#A28",
      "id": "B28"
    }
  }, [_vm._v("2")])]), _vm._v(". Yet in the reformed pronunciation the position of the accent-mark is wholly ignored, and the stress is placed according to the rules of stress in Latin, which require a knowledge of the length of vowels. In the case of two of the Greek vowels there is no difficulty, since η ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ē")]), _vm._v(") and ω ("), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ō")]), _vm._v(") are always long, and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("∊ (e")]), _vm._v(") and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("o (o")]), _vm._v(") are always short; but the length of "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("α (a), ι (i")]), _vm._v(") and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("υ (u")]), _vm._v(") can only be determined on etymological grounds, so that those who are ignorant of Greek are necessarily at a loss. Fortunately this reformed pronunciation is used only for the very few words which are transliterated wholly according to the modern system.")]), _vm._v(" "), _c('p', {
    staticClass: "indent5"
  }, [_vm._v("(3) "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("The pronunciation of Modern Greek.")]), _vm._v(" Since Greek, unlike Latin, is not a dead language, the pronunciation of modern Greek (which differs extensively from that of ancient Greek) must also be taken into account. Since there are only three words in this dictionary which are derived from Modern Greek—"), _c('em', {
    staticClass: "italic"
  }, [_vm._v("moussaka, ouzo,")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("retsina—")]), _c('a', {
    attrs: {
      "id": "page_44"
    }
  }), _vm._v("there is no need to discuss the modern pronunciation in detail; it is sufficient to remark that "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("a, e, i")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("o")]), _vm._v(" are pronounced as in Italian, and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("ou")]), _vm._v(" as in French.")]), _vm._v(" "), _c('h4', {
    staticClass: "head2",
    attrs: {
      "id": "id24"
    }
  }, [_vm._v("L"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ANGUAGES WRITTEN IN NON")]), _vm._v("-R"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OMAN SCRIPTS")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("With the exception of Russian all the languages written in scripts or alphabets other than the Roman alphabet are Oriental languages; and with them must be included Turkish which, though it is now written with the Roman alphabet, was written in the Arabic script when the vast majority of English borrowings from it were introduced into the language. Here too it is convenient to include languages like Eskimo and Hawaiian, which have no native script and until recent times were never written down. Most of the languages included in this group offer few difficulties of pronunciation, since the accepted English form is usually one which will convey, in terms of English spelling conventions, an approximation to the correct pronunciation. Thus, such words as "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("anorak, charpoy, howdah, kilim, mahout, sampan, sarong, sepoy, tarboosh")]), _vm._v(" can hardly be mispronounced if the combinations of letters are given their ordinary English values.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The problem here, if problem there is, is rather one of spelling: the few who have some knowledge of a little-known language may tend to become impatient with what seems to them an unscientific system of transliteration, and to substitute one which seems to them preferable. For this reason it is not uncommon to find such words as "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("krees, ranee, sheikh, suttee, syce")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("taboo")]), _vm._v(" written "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("kris, rani, shaikh, sati, sais")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("tabu")]), _vm._v(" respectively. In some cases the supposedly more scientific form seems to have ousted the traditional form completely: "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("babu, guru, hammam, sari")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("umiak")]), _vm._v(" must now be considered the standard forms in place of the earlier and preferable "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("baboo, gooroo, hummum, saree")]), _vm._v(" and "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("oomiak")]), _vm._v(" (though "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("igloo")]), _vm._v(" still retains its "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("oo).")]), _vm._v(" Of course in a systematic treatise on a foreign language a ‘scientific’ system of transliteration is eminently desirable; but those who alter, or attempt to alter, the traditional spelling overlook the fact that for ‘foreign’ words in current speech the most important factor is that the approximate pronunciation should be immediately obvious. The interpretation of the traditional spellings requires no special knowledge, but a ‘scientific’ transliteration is meaningless unless the principles of the system are properly understood, and the value to be attributed to each symbol has been memorized. The spelling "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("syce,")]), _vm._v(" for instance, is obviously based on English spelling conventions, and there can be no doubt at all what pronunciation is intended. The spelling "), _c('em', {
    staticClass: "italic"
  }, [_vm._v("sais,")]), _vm._v(" on the other hand, is ambiguous: if the word had entered "), _c('a', {
    attrs: {
      "id": "page_45"
    }
  }), _vm._v("English through French it would suggest one pronunciation, if through Italian another; in itself the spelling does not supply enough information for the pronunciation to be determined with confidence.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e3e35352","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/06_Introduction_1.vue
// module id = 81
// module chunks = 0